import { ManuteRequestConfig } from '@/api/types';
import { UserVacationHourRequest, UserVacationHourQueryParams, UserVacationHourRemainingsQueryParams } from '@/api/requests/vacation/types';

/**
 * Request to find all user-vacation-hours.
 * @param params
 */
export const ALL = (params?: UserVacationHourQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: '/user-vacation-hours',
    params: {
        page_size: 50,
        ...params,
    },
});

/**
 * Request to save a new user-vacation-hour.
 * @param data
 */
export const STORE = (data: UserVacationHourRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: '/user-vacation-hours',
    data,
});

/**
 * Request to find an user-vacation-hour by id.
 * @param userVacationHourId
 */
export const FIND = (userVacationHourId: number): ManuteRequestConfig => ({
    method: 'GET',
    url: `/user-vacation-hours/${userVacationHourId}`,
});

/**
 * Request to find an user-vacation-hour by id.
 * @param userVacationHourId
 */
export const REMAININGS = (params?: UserVacationHourRemainingsQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: `/user-vacation-hours/remainings`,
    params: params
});

/**
 * Request to update an existing user-vacation-hour.
 * @param userVacationHourId
 * @param data
 */
export const UPDATE = (userVacationHourId: number, data: UserVacationHourRequest): ManuteRequestConfig => ({
    method: 'PUT',
    url: `/user-vacation-hours/${userVacationHourId}`,
    data,
});

/**
 * Request to delete an user-vacation-hour by id.
 * @param userVacationHourId
 */
export const DELETE = (userVacationHourId: number): ManuteRequestConfig => ({
    method: 'DELETE',
    url: `/user-vacation-hours/${userVacationHourId}`,
});

/**
 * Request to delete an user-vacation-hour by id.
 * @param params
 */
export const DELETEWITHUSER = (params?: UserVacationHourQueryParams): ManuteRequestConfig => ({
    method: 'DELETE',
    url: `/user-vacation-hours`,
    params: {
        ...params,
    },
});
